import { render } from "./InputContainer.vue?vue&type=template&id=2c036b23&scoped=true"
import script from "./InputContainer.vue?vue&type=script&lang=js"
export * from "./InputContainer.vue?vue&type=script&lang=js"

import "./InputContainer.vue?vue&type=style&index=0&id=2c036b23&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c036b23"]])

export default __exports__